import React from 'react';
import { requireFromStaticAsset } from '../../utils/assetsUtils';
import MiniInfoBlock, { MiniInfoBlockProps } from '../mini-info-block/MiniInfoBlock';
import * as styles from './MiniInfoBlockList.style';

export interface MiniInfoBlockListProps {
  items: MiniInfoBlockProps[],
}

const MiniInfoBlockList: React.FC<MiniInfoBlockListProps> = ({
  items,
}) => (
  <ul css={styles.list}>
    {items.map((item) => (
      <li
        key={item.title}
        css={styles.item}
      >
        <MiniInfoBlock
          {...item}
          image={{
            ...item.image,
            src: requireFromStaticAsset(item.image.src),
          }}
        />
      </li>
    ))}
  </ul>
);

export default MiniInfoBlockList;
